import {getUrlSearch} from '@/utils/getUrlSearch';

export const useUserInfo = () => {
  const searchJson = getUrlSearch();

  // 用户信息
  const sid = searchJson.sid as string || '';
  const userId = +searchJson.userId as number || 0;

  return {sid, userId};
};
